import React from "react";

import RoomHeader from "../RoomHeader";
import RoomInfo from "./RoomInfo";
import RoomNavigationCard from "./RoomNavigationCard";

import { FaRegMap } from "react-icons/fa";

const Landingpage = ({ selectedRoom, swiperComponent, troubleReportData }) => {
  return (
    <div className="room-details">
      <RoomHeader
        title="Details"
        subtitle={selectedRoom.hoersaal}
        icon={<FaRegMap className="section-indocator-icon" />}
      />

      <div className="swiper-slide-section">
        <RoomInfo
          selectedRoom={selectedRoom}
          troubleReportData={troubleReportData}
        />
      </div>

      <div className="swiper-slide-section">
        <div className="room-quick-navigation">
          <h3>Schnellnavigation</h3>
          <RoomNavigationCard
            content={"Wegbeschreibung zu anderen Orten"}
            onClickTrigger={() => swiperComponent.slideTo(1)}
          />
          <RoomNavigationCard
            content={"Raumkapazität & Barrierefreiheit"}
            onClickTrigger={() => swiperComponent.slideTo(2)}
          />
          <RoomNavigationCard
            content={"Raumausstattung & Technik"}
            onClickTrigger={() => swiperComponent.slideTo(3)}
          />
          <RoomNavigationCard
            content={"Belegungsplan"}
            onClickTrigger={() => swiperComponent.slideTo(4)}
          />
          <RoomNavigationCard
            content={"Individuelle Störungsmeldungen"}
            onClickTrigger={() => swiperComponent.slideTo(5)}
          />
          <RoomNavigationCard
            content={"Bildergalerie"}
            onClickTrigger={() => swiperComponent.slideTo(6)}
          />
        </div>
      </div>
    </div>
  );
};

export default Landingpage;
